import { el } from 'redom';

import positionTypes from 'constants/position-types';

const positionTypeLabelMap = {
  [positionTypes.TOP]: 'Top',
  [positionTypes.RIGHT]: 'Right',
  [positionTypes.BOTTOM]: 'Bottom',
  [positionTypes.LEFT]: 'Left'
};

class PositionControl {

  constructor(configuration) {

    this.position = configuration.position;
    this.onChange = configuration.onChange;

    this.el = el('.position-control-main', [
      this.renderPositionInputs()
    ]);

  }

  renderPositionInput(position) {

    let cls = position;

    if (position === this.position) {
      cls += ' selected';
    }

    const input = el('button.position-control-button', {
      type: 'button',
      class: cls,
      onclick: this.handlePositionInputClick.bind(this, position)
    }, [positionTypeLabelMap[position]]);

    return input;

  }

  renderPositionInputs() {

    const positionInputs = [];

    const positions = [
      positionTypes.TOP,
      positionTypes.RIGHT,
      positionTypes.BOTTOM,
      positionTypes.LEFT
    ];

    for (let position of positions) {

      const positionInput = this.renderPositionInput(position);

      positionInputs.push(positionInput);

    }

    return positionInputs;

  }

  handlePositionInputClick(position, event) {

    event.preventDefault();
    event.stopPropagation();

    if (position === this.position) {
      return;
    }

    this.activatePosition(event.target, position);

  }

  doActivatePosition(button, position) {

    const current = this.el.querySelector('.active');

    if (current !== null) {
      current.classList.remove('active');
    }

    if (button !== null && button.classList.contains('active') === false) {
      button.classList.add('active');
    }

    this.position = position;

  }

  activatePosition(button, position) {

    this.doActivatePosition(button, position);

    this.onChange(position);

  }

  update(configuration) {

    this.position = configuration.position;
    this.onChange = configuration.onChange;

    const button = this.el.querySelector('button.' + this.position);

    this.doActivatePosition(button, this.position);

  }

}

export default PositionControl;